import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
  migrationAgronomistRoute,
  migrationGrowerRoute
} from '../../../../../e2e/constants/migration-redirect-routes.const';
import { MigrationBusinessOptions } from '../../../shared/constants/migration-business-options.const';
import { GatekeeperModalComponent } from '../../modal.component';

@Component({
  selector: 'gk-import-business-modal',
  templateUrl: './import-business-modal.component.html'
})
export class ImportBusinessModalComponent extends GatekeeperModalComponent<ImportBusinessModalComponent> {
  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<ImportBusinessModalComponent>
  ) {
    super();
  }

  async importBusiness(selectedMigrationOption: any) {
    this.close();
    switch (selectedMigrationOption) {
      case MigrationBusinessOptions.IMPORT_FROM_GATEKEEPER_GROWER:
      case MigrationBusinessOptions.IMPORT_FROM_TELUS_FARM_GROWER: //grower initiated migration
        await this.router.navigate([migrationGrowerRoute.route], {
          queryParams: {
            source: 'setup-business',
            migrationType: selectedMigrationOption
          },
          replaceUrl: true,
          skipLocationChange: true
        });
        break;
      case MigrationBusinessOptions.IMPORT_FROM_GATEKEEPER_AGRONOMIST:
      case MigrationBusinessOptions.IMPORT_FROM_TELUS_FARM_AGRONOMIST: //migration from agronomist
        await this.router.navigate([migrationAgronomistRoute.route], {
          queryParams: {
            source: 'setup-business',
            migrationType: selectedMigrationOption
          },
          replaceUrl: true,
          skipLocationChange: true
        });
        break;
    }
  }
}
